"use strict";

exports.__esModule = true;
var _ReportDataProvider = require("./ReportDataProvider");
Object.keys(_ReportDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportDataProvider[key]) return;
  exports[key] = _ReportDataProvider[key];
});
var _StandardReportDataProvider = require("./StandardReportDataProvider");
Object.keys(_StandardReportDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _StandardReportDataProvider[key]) return;
  exports[key] = _StandardReportDataProvider[key];
});
var _DeviceDetailsReportDataProvider = require("./DeviceDetailsReportDataProvider");
Object.keys(_DeviceDetailsReportDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsReportDataProvider[key]) return;
  exports[key] = _DeviceDetailsReportDataProvider[key];
});